import styled from "styled-components";

export const Experience = styled.div`
  display: flex;
  flex-direction: column;
  color: white;
  padding: 30px;
  h2 {
    font-weight: 400;
  }
`;
export const Cells = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  font-family: "Neue Machina";
  border-bottom: 1px solid #9f9f9f;
  p {
    color: #9f9f9f;
  }
  h3 {
    color: rgb(204, 204, 204);
    font-weight: 500;
  }
  .icon {
    padding: 10px;
    background-color: white;
    display: flex;
    justify-content: center;
    border-radius: 10px;
  }
`;
export const Resume = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  max-width: 1400px;
  margin-inline: auto;
  background-color: black;
  @media (max-width: 950px) {
    grid-template-columns: 1fr;
  }
  font-family: "Neue Machina";
`;
export const Skills = styled.div`
  font-family: "Neue Machina";
  gap: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  div {
    background-color: #2a2a2a;
    height: 40px;
    width: fit-content;
    border-radius: 30px;
    display: flex;
    flex: 1 1 50;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px;
    font-size: 30px;
    line-height: 50px;
    font-family: "Protest Guerrilla", sans-serif;
    @media (max-width: 560px) {
      height: 50px;
      width: 50px;
      flex: 1 1 50px;
      font-size: 20px;
    }
  }
`;
export const SkillsContainer = styled.div`
  background-color: rgb(0, 0, 0);
  max-width: 1400px;
  color: white;
  margin-inline: auto;
  margin-bottom: 30px;
  padding: 50px 30px 100px;
  box-sizing: border-box;
  text-align: center;
  h1 {
    font-size: 50px;
    font-weight: 500;
    font-family: "Neue Machina";
    @media (max-width: 560px) {
      font-size: 30px;
    }
  }
`;
export const AboutContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr; /* Stack vertically on small screens */
    text-align: center;
  }
`;

export const ProfileAboutPic = styled.img`
  border-radius: 10px;
  /* filter: drop-shadow(10px 10px 20px rgba(130, 107, 81, 0.505)); */
  background-color: rgba(176, 165, 126, 0.342);
  margin: auto;
  transform: scaleX(-1);
  h1 {
    /* margin-top: 50px; */
  }
  @media (max-width: 500px) {
    width: 100%;
  }
`;
